import { createContext, useContext } from "react"
import maplibregl from "maplibre-gl"

export const MapLibreContext = createContext<maplibregl.Map | null>(null)
export const useMapLibre = () => useContext(MapLibreContext)
